import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  openTimingPlaceModalAction,
  useAppDispatch,
} from '../../../../../redux';
import { SimpleButton } from '../../../../common/Buttons';
import { InputField } from '../../../../common/Inputs';
import { Row } from '../../../../common/LayoutComponents';
import { ChooseTimingPlaceDropdown } from '../../../../StopRegistry/Stops/Common';

const testIds = {
  latitude: 'StopFormComponent::latitude',
  longitude: 'StopFormComponent::longitude',
  timingPlaceDropdown: 'StopFormComponent::timingPlaceDropdown',
  addTimingPlaceButton: 'StopFormComponent::addTimingPlaceButton',
};

type TimingPlaceProps = { readonly className?: string };

export const TimingPlace: FC<TimingPlaceProps> = ({ className }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  return (
    <Row className={className}>
      <InputField
        translationPrefix="stops"
        fieldPath="timingPlaceId"
        testId={testIds.timingPlaceDropdown}

        inputElementRenderer={(props) => (
          <ChooseTimingPlaceDropdown {...props} />
        )}
        className="flex-1"
      />
      <SimpleButton
        className="ml-6 self-end"
        onClick={() => dispatch(openTimingPlaceModalAction())}
        testId={testIds.addTimingPlaceButton}
        inverted
      >
        {t(($) => $.stops.createTimingPlace)}
      </SimpleButton>
    </Row>
  );
};
